module.exports = __webpack_public_path__ + "img/miei-avvisi-white.86a47302.svg";